webpackJsonp([180],{

/***/ 1196:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PlatformUserRoleForm_vue__ = __webpack_require__(2908);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4fd04544_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PlatformUserRoleForm_vue__ = __webpack_require__(5186);
function injectStyle (ssrContext) {
  __webpack_require__(5179)
  __webpack_require__(5181)
  this["$style"] = __webpack_require__(5183)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4fd04544"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PlatformUserRoleForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4fd04544_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PlatformUserRoleForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1345:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = makeRule;
/*
 * 根据给定的多个文件路径引入模块
 * @Author: anker.wang
 * @Date: 2018-01-08 11:23:04
 * @Last Modified by: anker.wang
 * @Last Modified time: 2018-07-26 12:37:26
 */

/**
 * 快速制作验证规则
 * https://github.com/yiminghe/async-validator
 * @param {*} message
 * @param {*} type
 * @param {*} trigger
 * @param {*} required
 *
 string: Must be of type string. This is the default type.
 number: Must be of type number.
 boolean: Must be of type boolean.
 method: Must be of type function.
 regexp: Must be an instance of RegExp or a string that does not generate an exception when creating a new RegExp.
 integer: Must be of type number and an integer.
 float: Must be of type number and a floating point number.
 array: Must be an array as determined by Array.isArray.
 object: Must be of type object and not Array.isArray.
 enum: Value must exist in the enum.
 date: Value must be valid as determined by Date
 url: Must be of type url.
 hex: Must be of type hex.
 email: Must be of type email.
 */
function makeRule(message) {
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'string';
  var trigger = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'blur';
  var required = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;

  var rule = { message: message, type: type, trigger: trigger, required: required };
  rule.transform = function (value) {
    // 为空字符串时转换为null
    value === '' && (value = null);
    // 数字类型忽略为null的数字转换
    if (value !== null && ['number', 'integer', 'float'].includes(type)) {
      value = Number(value);
    }
    return value;
  };
  return rule;
}

/***/ }),

/***/ 1352:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1357), __esModule: true };

/***/ }),

/***/ 1357:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(234);
__webpack_require__(143);
module.exports = __webpack_require__(1358);


/***/ }),

/***/ 1358:
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(41);
var get = __webpack_require__(145);
module.exports = __webpack_require__(12).getIterator = function (it) {
  var iterFn = get(it);
  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
  return anObject(iterFn.call(it));
};


/***/ }),

/***/ 2908:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(1352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__platform_user_rules_js__ = __webpack_require__(5185);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  data: function data() {
    return {
      roleType: this.$route.params.type,
      formRules: __WEBPACK_IMPORTED_MODULE_4__platform_user_rules_js__["a" /* userRoleFormRules */],
      platformlist: [],
      currentPlatform: {
        name: ''
      },
      uiRole: {
        name: 'UI权限',
        host: ''
      },
      form: {
        admin_ids: [],
        role_ids: []
      }
    };
  },

  computed: {
    onUiRole: function onUiRole() {
      return this.roleType && this.roleType === this.uiRole.name;
    }
  },
  watch: {},
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    next(function (vm) {
      return vm.onLoad();
    });
  },
  beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
    this.onReload();
    next();
  },
  created: function created() {
    this.fetchPlatformlist();
  },
  mounted: function mounted() {},

  methods: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, request.map(['getBasicPlatformUsersIndex']), {
    getRoles: function getRoles(params) {
      var apiName = this.onUiRole ? 'getUiRolesIndex' : 'getRolesIndex';
      if (this.currentPlatform) {
        params.host = this.currentPlatform.host;
      }
      return request.page(apiName, params);
    },
    onLoad: function onLoad() {},
    onReload: function onReload() {
      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()(this.$data, this.$options.data.call(this));
      this.onLoad();
    },
    getForm: function getForm() {
      return filter.copyJson(this.form);
    },
    onSubmit: function onSubmit() {
      var _this = this;

      this.$refs['form'].validate(function (valid) {
        if (valid) {
          _this.id ? _this.update(_this.id) : _this.create();
        } else {
          _this.$message.error('提交内容填写不正确！');
        }
      });
    },
    create: function create() {
      var _this2 = this;

      var params = this.getForm();
      var apiName = this.onUiRole ? 'batchSetAdminUIRoles' : 'batchSetAdminRoles';
      if (this.currentPlatform) {
        params.host = this.currentPlatform.host;
      }
      params.admin_ids.forEach(function (adminId) {
        var data = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, params, { admin_id: adminId });
        delete data.admin_ids;
        request.common(apiName, data).then(function () {
          _this2.$confirm(_this2.$route.name + '成功, 是否继续分配？', '提示', { type: 'success' }).then(function () {
            _this2.$refs.form.resetFields();
          }, function () {
            _this2.$router.push({ path: '/platform-user' });
          });
        });
      });
    },
    fetchPlatformlist: function fetchPlatformlist() {
      var _this3 = this;

      this.platformlist = [];
      return request.common('getPermissionPlatformlist', {}).then(function (_ref) {
        var _platformlist;

        var data = _ref.data;

        _this3.platformlist.push(data.main);
        (_platformlist = _this3.platformlist).push.apply(_platformlist, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(data.others));
        _this3.platformlist.push({
          name: 'UI权限',
          host: null
        });

        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(_this3.platformlist), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var one = _step.value;

            if (one.name === _this3.roleType) {
              _this3.currentPlatform = one;
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      });
    }
  })
});

/***/ }),

/***/ 5179:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(5180);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("4ca6fc0c", content, true, {});

/***/ }),

/***/ 5180:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"PlatformUserRoleForm.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 5181:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(5182);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("dc1c7a64", content, true, {});

/***/ }),

/***/ 5182:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"PlatformUserRoleForm.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 5183:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(5184);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("7fca2182", content, true, {});

/***/ }),

/***/ 5184:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"PlatformUserRoleForm.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 5185:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return userRoleFormRules; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_utils_rule_js__ = __webpack_require__(1345);


var userRoleFormRules = {
  admin_ids: [Object(__WEBPACK_IMPORTED_MODULE_0__core_utils_rule_js__["a" /* makeRule */])('请选择管理员', 'array')],
  role_ids: [Object(__WEBPACK_IMPORTED_MODULE_0__core_utils_rule_js__["a" /* makeRule */])('请选择角色', 'array')]
};

/***/ }),

/***/ 5186:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"title",rawName:"v-title",value:(_vm.$route.name),expression:"$route.name"}]},[_c('div',{staticClass:"page-heading"},[_c('el-breadcrumb',{attrs:{"separator-class":"el-icon-arrow-right"}},[_c('el-breadcrumb-item',{attrs:{"to":{ path: '/' }}},[_vm._v("首页")]),_vm._v(" "),_c('el-breadcrumb-item',{attrs:{"to":{ path: '/platform-user' }}},[_vm._v("后台用户管理")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v(_vm._s(_vm.$route.name))])],1)],1),_vm._v(" "),_c('layout-panel',[_c('span',{attrs:{"slot":"header"},slot:"header"},[_vm._v("批量分配"+_vm._s(_vm.currentPlatform.name)+"角色")]),_vm._v(" "),_c('el-form',{ref:"form",attrs:{"model":_vm.form,"rules":_vm.formRules,"size":"medium","label-width":"140px"},nativeOn:{"submit":function($event){$event.preventDefault();return _vm.onSubmit()}}},[_c('div',{staticClass:"re-el-form__flex"},[_c('div',{staticClass:"medium"},[_c('el-form-item',{attrs:{"label":"管理员","prop":"admin_ids"}},[_c('remote-select',{staticClass:"width-max",attrs:{"id-key":"id","label-key":"name","value-key":"id","keyword-key":"name","placeholder":"请选择","multiple":"","query-request":_vm.getBasicPlatformUsersIndex},model:{value:(_vm.form.admin_ids),callback:function ($$v) {_vm.$set(_vm.form, "admin_ids", $$v)},expression:"form.admin_ids"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"角色名","prop":"role_ids"}},[_c('remote-select',{staticClass:"width-max",attrs:{"id-key":"id","label-key":"name","value-key":"id","keyword-key":"name","placeholder":"请选择","multiple":"","query-request":_vm.getRoles},model:{value:(_vm.form.role_ids),callback:function ($$v) {_vm.$set(_vm.form, "role_ids", $$v)},expression:"form.role_ids"}})],1)],1)]),_vm._v(" "),_c('el-form-item',[_c('el-button',{attrs:{"type":"primary","native-type":"submit"}},[_vm._v("提交表单\n        ")]),_vm._v(" "),_c('el-button',{on:{"click":_vm.onReload}},[_vm._v("重置")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/PlatformUserDIspatchRolesPermissions.834cd01c340fd3831090.js